// src/pages/Ilan_Yayinlama_Kurallari.jsx
import React from "react";

const Ilan_Yayinlama_Kurallari = () => {
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.title}>İLAN YAYINLAMA KURALLARI VE ÜYE YÜKÜMLÜLÜKLERİ</h1>

        <section style={styles.section}>
          <h2 style={styles.heading}>1. İlan İçeriğinin Doğruluğu, Güncelliği ve Hukuka Uygunluğu</h2>
          <p style={styles.text}>
            <strong>1.1.</strong> Üye/İlan Sahibi, Platform'da yayınladığı her bir ilanın içeriğinin; tamamen gerçeğe uygun, güncel, eksiksiz ve hukuka uygun olduğunu garanti eder. İlan sahibi, ilanı yayınlamadan önce içerikte yer alan tüm bilgileri (fiyat, konum, metrekare, yaş, aidat, tapu ve mülkiyet durumu vb.) titizlikle kontrol etmek ve güncellemekle yükümlüdür.
          </p>
          <p style={styles.text}>
            <strong>1.2.</strong> İlan Sahibi, yayınladığı ilan içeriği ile ilgili olarak gerekli tüm hak, rıza ve yetkilere (telif hakkı, kişisel verilerin işlenmesi izni, gayrimenkulün tanıtım ve pazarlaması için yetki vb.) sahip olduğunu kabul, beyan ve taahhüt eder. Üçüncü kişilerin her türlü fikri ve sınai mülkiyet haklarına saygı göstermekle yükümlüdür.
          </p>
          <p style={styles.text}>
            <strong>1.3.</strong> İlan içeriğinden (fotoğraf, video, metin, plan, harita vb.) ve bu içeriğin yayınlanmasından doğacak her türlü hukuki, idari ve cezai sorumluluk münhasıran İlan Sahibi'ne aittir. Şirket, içeriklerin doğruluğunu, orijinalliğini veya hukuka uygunluğunu kontrol etme yükümlülüğü taşımaz.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>2. Mükerrer (Yinelenen) İlan Yasağı</h2>
          <p style={styles.text}>
            <strong>2.1.</strong> Her bir gayrimenkul için, Platform'da aynı anda yalnızca tek bir aktif ilan yayınlanabilir. Bu kural, hem bireysel hem de kurumsal üyelikler için geçerlidir.
          </p>
          <p style={styles.text}>
            <strong>2.2.</strong> Aynı gayrimenkul için, aynı veya farklı üyelik hesapları altında birden fazla ilan tespit edilmesi durumunda, Şirket herhangi bir ön bildirimde bulunmaksızın mükerrer olduğunu değerlendirdiği ilan veya ilanları tamamen kendi inisiyatifiyle tespit ederek sistemden kaldırma, askıya alma veya yayından çıkarma hakkını saklı tutar. Tekrarlanan ihlaller, üyeliğin tamamen sonlandırılması ile sonuçlanabilir.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>3. İlan Görselleri ile İlgili Kurallar</h2>
          <p style={styles.text}>
            <strong>3.1.</strong> İlanlarda kullanılan tüm fotoğraf ve videolar, ilanı verilen spesifik gayrimenkulün gerçek, güncel ve tanıtıcı görüntülerinden oluşmalıdır.
          </p>
          <p style={styles.text}>
            <strong>3.2.</strong> Görseller üzerinde; emlak ofisi, inşaat şirketi veya kişiye ait logo, watermark (filigran), web sitesi adresi, e-posta, telefon numarası veya benzeri iletişim ve tanıtım bilgileri bulunamaz. Şirket, bu tür görselleri tespit ettiği takdirde, ilan sahibine bilgi vermeksizin, görseli kaldırma veya ilanı düzenleme hakkına sahiptir.
          </p>
          <p style={styles.text}>
            <strong>3.3.</strong> Stok fotoğrafları, temsili resimler, internetten alınan rastgele görüntüler veya gayrimenkul ile doğrudan bağlantısı olmayan her türlü içerik ilanlarda kullanılamaz.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>4. İlan Başlığı ve Açıklama Metni Kuralları</h2>
          <p style={styles.text}>
            <strong>4.1.</strong> İlan başlığı ve açıklama metni, yalnızca ilanı verilen gayrimenkulün fiziksel özellikleri, konumu, durumu ve satış/kira şartlarına ilişkin bilgileri içermelidir.
          </p>
          <p style={styles.text}>
            <strong>4.2.</strong> Başlık ve açıklamada; reklam amaçlı, yanıltıcı, spam niteliğinde, rakip firmaları hedef alan, hakaret veya ayrımcılık içeren, arama motorlarını manipüle etmaya yönelik anahtar kelime yığınlarına yer verilemez. Şirket markası veya rakip markaların isimleri başlıkta kullanılamaz.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>5. Satış/Kira Süreci Tamamlanan veya İptal Edilen İlanların Yönetimi</h2>
          <p style={styles.text}>
            <strong>5.1.</strong> Satışı veya kiralanması gerçekleşen, artık piyasada arz edilmeyen veya yayından kaldırılması gereken gayrimenkullere ait ilanların, İlan Sahibi tarafından derhal "Satıldı", "Kiralandı" olarak işaretlenmesi veya Platform'un "Arşiv" özelliği kullanılarak aktif ilan listesinden çıkarılması zorunludur.
          </p>
          <p style={styles.text}>
            <strong>5.2.</strong> Aktif durumda olmayan bu ilanların, kullanıcıları yanıltmak veya sistemde görünürlük sağlamak amacıyla açık tutulması kural ihlali sayılır.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>6. Genel Kabul ve Taahhüt</h2>
          <p style={styles.text}>
            <strong>6.1.</strong> İlan Sahibi, www.temelden.com.tr Platform'unda ilan yayınlayarak; Şirket tarafından önceden ilan edilmek kaydıyla her zaman güncellenebilme ihtimali olan bu "İlan Yayınlama Kuralları"nı, "Üyelik Sözleşmesi"ni, "Kullanım Koşulları"nı ve "Gizlilik Politikası"nı tamamen okuduğunu, anladığını ve bu belgelerde yer alan tüm hüküm, şart ve yükümlülüklere eksiksiz ve koşulsuz olarak uyacağını kabul, beyan ve taahhüt eder.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>7. Kural İhlallerinde Uygulanacak Yaptırımlar</h2>
          <p style={styles.text}>
            <strong>7.1.</strong> Yukarıda belirtilen kurallar ve genel taahhütler çerçevesinde hareket etmeyen İlan Sahipleri hakkında, Şirket aşağıdaki yaptırımları uygulamaya yetkilidir:
          </p>
          <ul style={styles.list}>
            <li><strong>İlana Müdahale:</strong> İhlal içeren ilanın veya ilan içeriğinin (fotoğraf, başlık, açıklama vb.) bir kısmının veya tamamının sistemden silinmesi, düzeltilmesi veya yayınının askıya alınması.</li>
            <li><strong>Kara Listeye Alınma:</strong> Tekrarlayan veya ağır ihlallerde, ilan sahibinin e-posta adresi, telefon numarası, IP adresi veya üyelik hesabının geçici veya kalıcı olarak kara listeye alınması. Bu durum, ilgili bilgilerle Platform'a gelecekte yapılacak üyelik veya ilan başvurularının engellenmesi anlamına gelir.</li>
            <li><strong>Üyeliğin Sona Erdirilmesi:</strong> İlan sahibinin üyeliğine, herhangi bir bildirimde bulunulmaksızın tek taraflı olarak derhal son verilmesi.</li>
            <li><strong>Sözleşmenin Feshi:</strong> İlan sahibi ile akdedilmiş olan "Üyelik Sözleşmesi"nin, Şirket tarafından tek taraflı olarak feshedilmesi.</li>
          </ul>
          <p style={styles.text}>
            <strong>7.2.</strong> Bu yaptırımların uygulanması, Şirket'in ihlallerden dolayı uğradığı maddi ve manevi zararların tazmini için yasal yollara başvurma hakkını saklı tutar.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Tanım</h2>
          <p style={styles.text}>
            <strong>"Kara Liste"</strong>, kural ihlali yapan bir üyenin kimlik, iletişim ve sistem bilgilerinin Şirket tarafından tutulan özel bir kaydıdır. Bu listeye alınan bir üye veya bilgi, Şirket'in takdiri doğrultusunda belirli bir süre veya süresiz olarak Platform'a tekrar üye olamaz veya ilan yayınlayamaz.
          </p>
        </section>
      </div>
    </div>
  );
};

const styles = {
  page: {
    backgroundColor: "#f7f7f7",
    minHeight: "100vh",
    padding: "60px 20px",
    display: "flex",
    justifyContent: "center",
  },
  container: {
    maxWidth: "900px",
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "40px 30px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    lineHeight: "1.7",
  },
  title: {
    fontSize: "24px",
    fontWeight: "700",
    textAlign: "center",
    marginBottom: "30px",
    color: "#222",
  },
  section: {
    marginBottom: "25px",
  },
  heading: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#333",
    marginBottom: "8px",
  },
  text: {
    fontSize: "14px",
    color: "#555",
    marginBottom: "10px",
  },
  list: {
    paddingLeft: "20px",
    color: "#555",
    fontSize: "14px",
    marginBottom: "10px",
  },
  link: {
    color: "#0056b3",
    textDecoration: "none",
  },
};

export default Ilan_Yayinlama_Kurallari;